export var DialogCommand;
(function (DialogCommand) {
    DialogCommand["UNLOCK"] = "UNLOCK";
    DialogCommand["SEND_DIALOG_CONFIRM"] = "sendDialogConfirm";
    DialogCommand["SEND_DIALOG_ERROR"] = "sendDialogError";
    DialogCommand["REGISTER"] = "register";
    DialogCommand["BROADCASTING_WITHOUT_CONFIRMATION"] = "broadcastingNoConfirm";
    DialogCommand["WRONG_MK"] = "WRONG_MK";
    DialogCommand["ANSWER_REQUEST"] = "answerRequest";
    DialogCommand["READY"] = "broadcastReady";
    DialogCommand["RETURN_SIGNATURE"] = "RETURN_SIGNATURE";
    DialogCommand["RETURN_ERROR_SIGNING_TRANSACTION"] = "RETURN_ERROR_SIGNING_TRANSACTION";
    DialogCommand["PING"] = "PING";
})(DialogCommand || (DialogCommand = {}));
export var MultisigDialogCommand;
(function (MultisigDialogCommand) {
    MultisigDialogCommand["READY_MULTISIG"] = "multisigReady";
    MultisigDialogCommand["MULTISIG_SEND_DATA_TO_POPUP"] = "MULTISIG_SEND_DATA_TO_POPUP";
})(MultisigDialogCommand || (MultisigDialogCommand = {}));
